import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentDocumentCollectionPage() {
  return (
    <LatamAgentPage locale="pt-BR" agentKey="document_collection_and_filing" />
  );
}
